<template>
  <div class="outBox">
    <Row type="flex" justify="center">
      <Button type="ghost">
        <Badge :count="count">
          <img :src="imageUrl" style="width:40px;height:40px;">
        </Badge>
      </Button>
    </Row>
    <Row type="flex" justify="center">
      <h6>{{title}}</h6>
    </Row>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: String,
    title: String,
    count: Number
  }
};
</script>

<style scoped lang="less">
.outBox {
  width: 130px;
  height: 118px;
  border-radius: 30px;
  padding: 14px 0;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  /deep/.ivu-btn {
    border: none;
  }
  h6 {
    width: 100px;
    text-align: center;
  }
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 2px 5px #ccc;
  }
}
.demo-badge{
  width: 42px;
  height: 42px;
  background: #eee;
  border-radius: 6px;
  display: inline-block;
}
</style>
